import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler, // Import Filler plugin
} from "chart.js";
import { useSelector } from "react-redux";

// Register Chart.js components and Filler plugin
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const TemperatureBarChart = ({ historicData }) => {
  // console.log('forecastData TemperatureBarChart:', forecastData)
  const { theme } = useSelector((store) => store.dashboard);
  ChartJS.defaults.borderColor = theme === "light" ? "#E2E8F0" : "#1E293B";
  // Extract dates and temperature data
  const dates = historicData.map((item) => {
    const dateObj = new Date(item.Date_time);
    const options = { month: "short", day: "numeric" };
    return dateObj.toLocaleDateString("en-US", options);
  });

  const tmin = historicData.map((item) => item.Tmin);
  const tmax = historicData.map((item) => item.Tmax);
  const days = dates.length;
  // Chart data configuration
  const data = {
    labels: dates,

    datasets: [
      {
        label: "T Min (°C)",
        data: tmin,
        backgroundColor: "rgba(14, 165, 233, 0.25)",
        borderColor: "rgba(14, 165, 233, 1)", // Optional border for bars
        borderWidth: 2,
      },
      {
        label: "T Max (°C)",
        data: tmax,
        backgroundColor: "rgba(244, 63, 94, 0.25)",
        borderColor: "rgba(225, 29, 72, 1)", // Optional border for bars
        borderWidth: 2,
      },
    ],
  };

  // Chart options configuration
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: theme === "light" ? "#475569" : "#94A3B8",

          font: {
            size: 12,
            weight: "500",
          },
        },
      },
      title: {
        display: true,
        text: `${days} Days Temperature Historical Data`,
        color: theme === "light" ? "#0F172A" : "#F8FAFC",

        font: {
          size: 16,
          weight: "bold",
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: theme === 'light' ? "rgba(15, 23, 42, 0.06)" : "rgba(248, 250, 252, 0.06)",
        },
        title: {
          display: true,
          text: "Temperature (°C)",
          color: theme === "light" ? "#475569" : "#94A3B8",
        },
        ticks: {
          color: theme === "light" ? "#64748B" : "#94A3B8",
        },
      },
      x: {
        grid: {
          color: theme === 'light' ? "rgba(15, 23, 42, 0.06)" : "rgba(248, 250, 252, 0.06)",
        },
        title: {
          display: true,
          text: "Date",
          color: theme === "light" ? "#475569" : "#94A3B8",
        },
        ticks: {
          color: theme === "light" ? "#64748B" : "#94A3B8",
        },
      },
    },
  };

  return (
    <div className="h-full w-full">
      <Line data={data} options={options} />
    </div>
  );
};

export default TemperatureBarChart;
